import React, { useCallback, useEffect, useRef, useState } from 'react';
import MessagesTab from '../../../../../components/MessageTab/MessageTab';
import { useDispatch, useSelector } from 'react-redux';
import {
  reviewsForChatter,
  reviewsForChatterPreview,
  reviewsFilterChatter,
  reviewsFilterChatterPreview,
  chatterReviewsForDownload,
} from '../../../../../store/redux/slices/chatterSlice';
import styled from 'styled-components';
import Button from '../../../../../Common/Button/Button';
import {
  AmazonIconSmall,
  FlipkartIconSmall,
  SearchIcon,
} from '../../../../../Common/SvgIcon/CommonSvgIcons';
import { flexbox } from '@mui/system';
import MyDatePicker from '../../../../../components/DatePicker/DatePicker';
import Lottie from 'lottie-react';
import Loader from '../../../../../assests/animation/Loader2.json';
import {
  searchPost,
  searchPostPreview,
  searchTextFunc,
} from '../../../../../store/redux/slices/topicSlice';
import { debounce } from 'lodash';
import FilterPanelPost from '../../../../../components/FilterPanelPost/FilterPanelPost';

const Wrapper = styled.div`
  display: flex;
  align-items: end;
  gap: 30px;
  margin: 30px;
  font-size: 15px;
  font-weight: 600;

  & > :first-child {
    box-shadow: 0px 0px 11px 0px rgba(63, 63, 63, 0.25) inset;
    padding: 8px 7px 5px 7px;
    border-radius: 10px;

    & svg {
      width: 30px;
      height: 30px;
    }
  }

  & input {
    box-shadow: 0px 0px 8px 0px #a2a2a23d;
    border: 1px solid #d9d9d9;
    margin-top: 5px;
    margin-left: -3px;
    font-family: Open Sans;
    font-size: 15px;
    font-weight: 400;
    color: #636363;

    padding: 5px 20px;
    border-radius: 5px;
  }
`;
const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  gap: 30px;
  font-size: 15px;
  font-weight: 600;
  padding: 30px 0px;
`;
const ContainerWithoutPadding = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  gap: 30px;
  font-size: 15px;
  font-weight: 600;
  padding: 0px 0px 30px 0px;
`;
const LogoImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 8px 0px #a2a2a23d;
  border: 1px solid #d9d9d9;
  width: 43px;
  height: 42px;
  border-radius: 5px;
  & svg {
    width: 20px;
    height: 20px;
    padding-top: 5px;
  }
`;
const ContainerInput = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  font-family: Inter;

  & input {
    box-shadow: 0px 0px 8px 0px #a2a2a23d;
    border: 1px solid #d9d9d9;
    margin-top: 5px;
    margin-left: -3px;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    color: #636363;

    padding: 5px 10px;
    border-radius: 5px;
  }
`;
const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  width: 96%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`;
function CommentsTab({
  email_id,
  download,
  job_id,
  channelName,
  startDate = '',
  endDate = '',
  hideDropdown,
  preview_uuid,
  min = '',
  max = '',

  formatValue = 'dd-MM-yyyy',
}) {
  const [loading, setLoading] = useState(false);
  const [firstDate, setFirstDate] = useState(startDate);
  const [lastDate, setLastDate] = useState(endDate);
  const [filterData, setFilteredData] = useState(null);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = useRef(null); // ✅ ref for scroll
  // const { reviewsForPreviewData } =
  //   useSelector((state) => state.chatterTracker) || {};
  const { searchText } = useSelector((state) => state.topicBuilder) || {};

  const { reviewsForChatterData } =
    useSelector((state) => state.chatterTracker) || {};

  // const { reviewsData } = useSelector((state) => state.chatterTracker) || {};
  const [isFilterEd, setIsFiltered] = useState(false);

  useEffect(() => {
    setFirstDate(startDate);
    setFilteredData(null);
  }, [startDate, job_id]);
  useEffect(() => {
    setFilteredData(null);
    setLastDate(endDate);
  }, [endDate, job_id]);
  const childRef = useRef();
  const prevJobIdRef = useRef(); // no initial value
  const [reset, setReset] = useState(0);

  useEffect(() => {
    if (prevJobIdRef.current !== job_id) {
      setIsFiltered(false);
      setReset(Date.now());
      prevJobIdRef.current = job_id;
    }
    if (
      childRef.current &&
      typeof childRef.current.handleClear === 'function'
    ) {
      childRef.current.handleClear(true);
    }

    if (download) {
      dispatch(chatterReviewsForDownload({ job_id, email_id }));
    } else if (typeof job_id === 'number' && reviewsForChatterData === null) {
      dispatch(reviewsForChatter(job_id));
    } else if (preview_uuid) {
      dispatch(reviewsForChatterPreview({ preview_uuid }));
    } else {
      dispatch(reviewsForChatter(job_id));
    }
  }, [job_id]);

  const dateHandler = (e) => {
    const { name, value } = e;
    // console.log(value,"value");
    const formatDate = (isoString) => {
      const date = new Date(isoString); // Create a Date object from the ISO string
      const year = date.getFullYear(); // Get the year
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get the month (0-based index, hence +1)
      const day = String(date.getDate()).padStart(2, '0'); // Get the day

      return `${year}-${month}-${day}`; // Return the formatted date
    };

    const formattedDate = formatDate(value);
    if (name === 'firstDate') {
      setFirstDate(formattedDate);
    } else if (name === 'lastDate') {
      setLastDate(formattedDate);
    }
  };

  const handleSave = () => {
    setLoading(true);
    const isValidDate = (date) => {
      return date instanceof Date && !isNaN(date.getTime());
    };

    const validateDate = (date) => {
      // Convert date strings to Date objects
      const start = new Date(min); // Explicitly parse the initialStartDate
      const end = new Date(max); // Explicitly parse the initialEndDate
      const datedate = new Date(date); // Explicitly parse the date to be validated

      if (!isValidDate(start) || !isValidDate(end) || !isValidDate(datedate))
        return false;

      const isAfterMin = datedate >= start;
      const isBeforeMax = datedate <= end;

      return isAfterMin && isBeforeMax;
    };
    if (validateDate(firstDate) && validateDate(lastDate)) {
      const dates = {
        start_date: firstDate,
        end_date: lastDate,
      };
      if (preview_uuid) {
        dispatch(reviewsForChatterPreview({ dates, preview_uuid }))
          .then((res) => {
            setFilteredData(res.payload.data.reviews);
            setLoading(false);
          })
          .catch((error) => {
            console.error('Error:', error); // Handling any errors
            setLoading(false);
          });
      } else {
        dispatch(reviewsFilterChatter({ dates, job_id }))
          .then((res) => {
            setFilteredData(res.payload.data.reviews);
            setLoading(false);
          })
          .catch((error) => {
            console.error('Error:', error); // Handling any errors
            setLoading(false);
          });
      }
    } else {
      alert(`Enter valid Input between ${min} and ${max}`);
    }
  };
  const debouncedSearch = useCallback(
    debounce((value, job) => {
      dispatch(searchPost({ keyword: value, job_id: job }))
        .then((res) => {
          setFilteredData(res.payload?.data?.reviews); // Assuming reviews are part of the response
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }, 500), // Debounce delay (500ms)
    [] // Empty dependency array means this function is created only once
  );
  const debouncedSearchPreview = useCallback(
    debounce((value, pre) => {
      dispatch(searchPostPreview({ keyword: value, job_id: pre }))
        .then((res) => {
          setFilteredData(res.payload?.data?.reviews); // Assuming reviews are part of the response
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }, 500), // Debounce delay (500ms)
    [] // Empty dependency array means this function is created only once
  );

  const handleChangeVal = (val) => {
    setCurrentPage(1);
    dispatch(searchTextFunc(val));
    if (job_id) {
      debouncedSearch(val, job_id);
    } else {
      debouncedSearchPreview(val, preview_uuid);
    }
  };

  return (
    <ContainerWrapper>
      <ContainerWithoutPadding style={{ justifyContent: 'end' }}>
        {/* <ContainerInput>
              <div>
                <input
                  id='search-input' // Add the id here
                  value={searchText}
                  width='100px'
                  name='lastPostDateReview'
                  style={{
                    minWidth: '375px',
                    minHeight: '30px',
                    width: '440px',
                    paddingRight: '35px',
                  }}
                  placeholder='Search by comment or profile'
                  onChange={(e) => handleChangeVal(e.target.value)}
                />

                <span
                  style={{ position: 'relative', right: '28px', top: '3px' }}
                >
                  {SearchIcon}
                </span>
              </div>
            </ContainerInput> */}
        <FilterPanelPost
          channel={channelName}
          lastDate={lastDate}
          startDate={firstDate}
          setFilteredData={(filterData) => {
            setFilteredData(filterData);
          }}
          isFilterEd={isFilterEd}
          setIsFiltered={(data) => setIsFiltered(data)}
          preview_uuid={preview_uuid}
          setLoading={(data) => setLoading(data)}
          manualResetTrigger={reset}
          job_id={job_id}
          isChatter={true}
          ref={childRef}
          setCurrentPage={setCurrentPage}
        />
      </ContainerWithoutPadding>
      <div
        ref={tableRef}
        style={{
          display: flexbox,
          flexDirection: 'column',
          width: '96%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '0px',
          scrollBehavior: 'smooth',
          maxHeight: '600px',
          overflowY: 'auto',
        }}
      >
        {channelName && !hideDropdown && (
          <ContainerWithoutPadding>
            <ContainerWithoutPadding>
              {/* <LogoImage>
              {channelName === 'flipkart' ? FlipkartIconSmall : AmazonIconSmall}
            </LogoImage> */}
              {/* <div>{channelName === 'flipkart' ? FlipkartIconSmall : AmazonIconSmall}</div> */}
              {/* <ContainerInput>
              <div>
                <div>First Date:</div> */}
              {/* <input
              type='date'
              name='firstDate'
              value={firstDate}
              onChange={dateHandler}
              min={startDate}
              max={endDate}
              />
              current work */}
              {/* <MyDatePicker
                  width='100px'
                  name='firstDate'
                  value={firstDate ? firstDate : ''}
                  dateHandler={dateHandler}
                  format={formatValue}
                  min={min ? min : ''}
                  max={max ? max : ''}
                />
              </div>
            </ContainerInput> */}
              {/* <ContainerInput>
              <div>
                <div>Last Date:</div> */}

              {/* current work */}
              {/* <MyDatePicker
                  width='100px'
                  name='lastDate'
                  value={lastDate ? lastDate : ''}
                  dateHandler={dateHandler}
                  format={formatValue}
                  min={min ? min : ''}
                  max={max ? max : ''}
                /> */}
              {/* <input
              type='date'
              name='lastDate'
              value={lastDate}
              onChange={dateHandler}
              min={startDate}
              max={endDate}
            /> */}
              {/* </div>
            </ContainerInput> */}

              {/* <Button
              value={'Save'}
              onClick={handleSave}
              style={{
                width: '100px',
                borderRadius: '10px',
                height: '35px',
                fontSize: '18px',
              }}
            /> */}
            </ContainerWithoutPadding>
          </ContainerWithoutPadding>
        )}
        {loading == true ? (
          <div style={{ marginTop: '-80px' }}>
            <Lottie
              data-testid='loader'
              animationData={Loader}
              loop={true}
              width='100px'
              height='100px'
            />
          </div>
        ) : (
          <MessagesTab
            tableRef={tableRef}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            channel={channelName}
            reviews={
              filterData ? filterData : reviewsForChatterData?.reviews || []
            }
            filterCol={channelName === 'flipkart' ? [2, 3, 4, 5] : [2, 3, 4]}
            graphStyles={{
              gridTemplateColumns:
                channelName === 'flipkart'
                  ? '45% 1fr 1fr 1fr 1fr'
                  : '45% 1fr 1fr 1fr',
            }}
            columns={
              channelName === 'flipkart'
                ? ['Comments', 'Profile', 'Likes', 'Dislikes', 'Rating']
                : ['Reviews', 'Profile', 'Helpful', 'Verified']
            }
          />
        )}
      </div>
    </ContainerWrapper>
  );
}

export default CommentsTab;
